import React, { useEffect, useMemo, useState } from 'react'

import Flex from '../Flex'

import { TabsProps } from './Tabs.types'
import { TabItemWrapper } from './styled'
import Text from '../Text'
import Icon from '../Icon'
import colors from '../../constants/colors'
import { AllIconNames } from '../Icon/Icon.types'

const Tabs: React.FC<TabsProps> = ({
  defaultActiveKey,
  placement = 'bottom',
  items,
  onChange,
  ...props
}) => {
  const [currentTab, setCurrentTab] = useState(defaultActiveKey)
  const indexChild = useMemo(() => items.findIndex((item) => item.key === currentTab), [currentTab])
  const ChildrenComponent = items[indexChild === -1 ? 0 : indexChild].children

  useEffect(() => {
    setCurrentTab(defaultActiveKey)
  }, [defaultActiveKey])

  const onChangeTab = (key: string) => {
    setCurrentTab(key)
    onChange(key)
  }

  // will tested later
  // istanbul ignore next
  const getDefaultWidth = (width: string, label: string) => {
    if (width) return width
    if (label.split(' ').length >= 2) return '160px'
    return '120px'
  }

  return (
    <Flex flexDirection='column'>
      <Flex overflowX='auto' overflowY='hidden'>
        <Flex
          flexDirection='row'
          backgroundColor='white'
          width='100%'
          borderTop={placement === 'top' ? `1px solid ${colors.black10}` : ''}
          borderBottom={placement === 'bottom' ? `1px solid ${colors.black10}` : ''}
          {...props}
        >
          {items.map(({ label: LabelComponent, width, ...item }, idx) => {
            const isActive = item.key === currentTab
            if (typeof LabelComponent === 'string') {
              return (
                <TabItemWrapper
                  isActive={isActive}
                  placement={placement}
                  key={`${item.key}-${idx}`}
                  onClick={() => onChangeTab(item.key)}
                  alignItems='center'
                  width={getDefaultWidth(width, LabelComponent)}
                  justifyContent='center'
                  position='relative'
                  cursor='pointer'
                  flexShrink={0}
                >
                  <Flex padding='10px' gap='8px'>
                    {item.iconName && (
                      <Icon
                        name={item.iconName as AllIconNames}
                        color={isActive ? 'blue50' : 'black50'}
                      />
                    )}
                    <Text
                      color={isActive ? 'blue50' : 'black50'}
                      weight={isActive ? 'bold' : 'regular'}
                    >
                      {LabelComponent}
                    </Text>
                  </Flex>
                </TabItemWrapper>
              )
            } else {
              return (
                <TabItemWrapper
                  isActive={isActive}
                  placement={placement}
                  key={`${item.key}-${idx}`}
                  onClick={() => onChangeTab(item.key)}
                  alignItems='center'
                  justifyContent='center'
                  position='relative'
                  cursor='pointer'
                  width={width || '160px'}
                  flexShrink={0}
                >
                  <LabelComponent isActive={isActive} />
                </TabItemWrapper>
              )
            }
          })}
        </Flex>
      </Flex>
      <ChildrenComponent />
    </Flex>
  )
}

export default Tabs
